var _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStep4(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A82939;}\n\t.st1{fill:none;stroke:#75232E;stroke-width:5;}\n\t.st2{fill:#A21B2C;}\n\t.st3{fill:none;stroke:#75232E;stroke-width:4;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.8,43.7L40,32.6c1-1.9,2-3.8,3-5.7h0.2C43.1,28.9,43,32,43,34v9.7H32.8z M43,58h5.4v-9.9H53v-4.4h-4.7V21.2 h-6.7L27,44.2v3.8h16V58z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 40,
    cy: 40,
    r: 37.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep4);
export default __webpack_public_path__ + "static/media/step4.de124497.svg";
export { ForwardRef as ReactComponent };